export const MapEventEnum = Object.freeze({
    boundsChanged: "boundsChanged",
    hover: "hover",
    idle: "idle",
    modeChanged: "modeChanged",
    mouseOut: "mouseout",
    click: "click",
    rightClick: "rightclick",
    drag: 'drag',
    dragEnd: "dragEnd",
    dragStart: "dragStart",
    mouseMove: "mousemove",
    dblClick: "dblClick",
    limitedZoom: "limitedZoom",
    cameraChanging: "cameraChanging",
    cameraWillChange: 'cameraWillChange',
    mouseOver: "mouseover"
});
